// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__9i0eJ","title":"Info_title__2zOte","links":"Info_links__1GUov","link":"Info_link__2ipks","logo":"Info_logo__2e1VI"};